<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 v-if="organizationUnitId" :tid="organizationUnitId"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Manage user's details</h1>

                    <a :href="`/#/admin/organizations/users/manage/${id}`" class="btn btn-link btn-sm">
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>
                        Back
                    </a>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container">
            <h3 class="fg-color-blue">User {{email}}</h3>
            <br />

            <div class="form-group">
                <label for="FirstName">First name:</label>
                <input v-model="inputFirstName" type="text" class="form-control" placeholder="First name of an user">
                <ValidationError context="FirstName" :errors="validationErrors"></ValidationError>
            </div>

            <div class="form-group">
                <label for="LastName">Last name:</label>
                <input v-model="inputLastName" type="text" class="form-control" placeholder="Last name of an user">
                <ValidationError context="LastName" :errors="validationErrors"></ValidationError>
            </div>

            <div class="form-group">
                <label for="DisplayName">Display name:</label>
                <input v-model="inputDisplayName" type="text" class="form-control" placeholder="Display name of an user">
                <ValidationError context="DisplayName" :errors="validationErrors"></ValidationError>
            </div>

            <button v-if="!invokingUpdateUserDetailsCommandV1" @click="invokeUpdateUserDetailsCommandV1" type="button" class="btn btn-primary btn-lg">Update</button>
            <button v-else type="button" class="btn btn-primary btn-lg" disabled>Updating...</button>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ref, computed, onMounted, watch } from 'vue'
    import { useRoute, useRouter } from 'vue-router'

    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'
    import ValidationError from '@common/Components/ValidationError.vue'

    import { useCurrentUserQueryV1, useUserQueryV1 } from '@Organizations/Users/queries-vue-composables'
    import { useUpdateUserDetailsCommandV1 } from '@Organizations/Users/commands-vue-composables'

    const route = useRoute()
    const router = useRouter()

    const id = computed(() => String(route.params.id))

    const inputFirstName = ref('')
    const inputLastName = ref('')
    const inputDisplayName = ref('')

    const { runCurrentUserQueryV1 } = useCurrentUserQueryV1(false, true, false)
    const {
        runUserQueryV1,
        modelUserQueryV1: user
    } = useUserQueryV1(id)

    const email = computed(() => user.value?.Email)
    const organizationUnitId = computed(() => user.value?.OrganizationUnitId)

    watch(user, (u) =>
    {
        if (!u) return

        inputFirstName.value = u.FirstName
        inputLastName.value = u.LastName
        inputDisplayName.value = u.DisplayName
    })

    const {
        invokeUpdateUserDetailsCommandV1,
        invokingUpdateUserDetailsCommandV1,
        succeedUpdateUserDetailsCommandV1,
        validationErrors
    } = useUpdateUserDetailsCommandV1(id, inputFirstName, inputLastName, inputDisplayName)

    onMounted(() =>
    {
        document.title = "Manage user's details"
        runCurrentUserQueryV1()
        runUserQueryV1()
    })

    watch(succeedUpdateUserDetailsCommandV1, (succeeded) =>
    {
        if (succeeded)
        {
            router.push(`/admin/organizations/users/manage/${id.value}`)
        }
    })
</script>
